
import { Component,Input,  OnInit } from '@angular/core';
import { LANG_CODE } from '../constants/Constants';
import { TranslocoService } from '@ngneat/transloco';



@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  pageName: string = '';
  year:string = '';
  langValue: string;


  

  constructor(private translocoService: TranslocoService) { 
    this.year = '';
  }

  

  ngOnInit() {
    this.year= new Date().getFullYear().toString();
     this.langValue=this.translocoService.getActiveLang();
     this.translocoService.langChanges$.subscribe((lang) => {
      this.langValue = lang;
      
   
   });
  }

}
